document.documentElement.classList.remove('no-js');

const Charmant = {
  routes: {
    cart: window.CharmantRoutes?.cart || '/cart',
    add: window.CharmantRoutes?.cartAdd || '/cart/add',
    change: window.CharmantRoutes?.cartChange || '/cart/change',
    collections: window.CharmantRoutes?.collections || '/collections'
  },
  toastTimer: null,
  lastFocused: null,
  money(cents) {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format((cents || 0) / 100);
  },
  escape(value = '') {
    const element = document.createElement('div');
    element.textContent = value;
    return element.innerHTML;
  },
  toast(message) {
    const toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(this.toastTimer);
    this.toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2800);
  },
  closePanels() {
    document.querySelectorAll('[data-mobile-nav], [data-search-panel]').forEach((el) => { el.hidden = true; });
    document.querySelectorAll('[data-mobile-toggle], [data-search-toggle]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('menu-open');
  },
  async getCart() {
    const response = await fetch(`${this.routes.cart}.js`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('No se pudo cargar el carrito');
    return response.json();
  },
  itemMarkup(item) {
    const image = item.featured_image?.url || item.image || '';
    const imageUrl = image ? `${image}${image.includes('?') ? '&' : '?'}width=300` : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${this.escape(item.variant_title)}</p>` : '';
    return `<article class="cart-drawer__item" data-cart-item-key="${this.escape(item.key)}">
      <a class="cart-drawer__image" href="${this.escape(item.url)}">${imageUrl ? `<img src="${this.escape(imageUrl)}" alt="${this.escape(item.product_title)}" width="120" height="160">` : ''}</a>
      <div class="cart-drawer__item-info"><h3><a href="${this.escape(item.url)}">${this.escape(item.product_title)}</a></h3>${variant}<strong>${this.money(item.final_line_price)}</strong>
        <div class="cart-drawer__item-actions"><div class="quantity-control"><button type="button" data-cart-change="${this.escape(item.key)}" data-quantity="${Math.max(item.quantity - 1, 0)}" aria-label="Reducir cantidad">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${this.escape(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Aumentar cantidad">+</button></div><button class="cart-drawer__remove" type="button" data-cart-change="${this.escape(item.key)}" data-quantity="0">Eliminar</button></div>
      </div></article>`;
  },
  renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    const shell = document.querySelector('[data-cart-drawer-shell]');
    if (!shell) return;
    shell.querySelector('[data-cart-drawer-count]').textContent = `(${cart.item_count})`;
    const items = shell.querySelector('[data-cart-drawer-items]');
    const footer = shell.querySelector('[data-cart-drawer-footer]');
    if (!cart.item_count) {
      items.innerHTML = `<div class="cart-drawer__empty"><p>Tu carrito está esperando una pieza especial.</p><a class="button" href="${this.routes.collections}/dama">EXPLORAR MUJER</a></div>`;
      footer.hidden = true;
      return;
    }
    items.innerHTML = cart.items.map((item) => this.itemMarkup(item)).join('');
    footer.hidden = false;
    footer.querySelector('[data-cart-drawer-total]').textContent = this.money(cart.total_price);
    const freeShippingGoal = 50000000;
    const remaining = Math.max(freeShippingGoal - cart.total_price, 0);
    const shippingMessage = footer.querySelector('[data-cart-shipping-message]');
    const shippingBar = footer.querySelector('[data-cart-shipping-bar]');
    if (shippingMessage) {
      shippingMessage.innerHTML = remaining > 0
        ? `Te faltan <strong>${this.money(remaining)}</strong> para envío gratis. <a href="${this.routes.collections}/dama">Descubre más prendas →</a>`
        : '<strong>¡Tu pedido ya tiene envío gratis!</strong>';
    }
    if (shippingBar) shippingBar.style.width = `${Math.min((cart.total_price / freeShippingGoal) * 100, 100)}%`;
  },
  async refreshCart() {
    const cart = await this.getCart();
    this.renderCart(cart);
    return cart;
  },
  async openCart() {
    const shell = document.querySelector('[data-cart-drawer-shell]');
    if (!shell) return;
    this.lastFocused = document.activeElement;
    shell.removeAttribute('hidden');
    document.body.classList.add('cart-open');
    const items = shell.querySelector('[data-cart-drawer-items]');
    if (items) items.innerHTML = '<div class="cart-drawer__loading" role="status">Cargando tu selección…</div>';
    shell.querySelector('[data-cart-drawer]')?.focus();
    try {
      await this.refreshCart();
    } catch (error) {
      if (items) items.innerHTML = `<div class="cart-drawer__error"><p>No pudimos cargar el carrito en este momento.</p><a class="button" href="${this.routes.cart}">ABRIR CARRITO COMPLETO</a></div>`;
      throw error;
    }
  },
  closeCart() {
    document.querySelector('[data-cart-drawer-shell]')?.setAttribute('hidden', '');
    document.body.classList.remove('cart-open');
    if (this.lastFocused instanceof HTMLElement) this.lastFocused.focus();
  },
  async changeCart(key, quantity) {
    const response = await fetch(`${this.routes.change}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error('No se pudo actualizar el carrito');
    const cart = await response.json();
    this.renderCart(cart);
    return cart;
  }
};

document.addEventListener('click', async (event) => {
  const cartOpen = event.target.closest('[data-cart-open]');
  if (cartOpen) { event.preventDefault(); try { await Charmant.openCart(); } catch { Charmant.toast('Puedes continuar desde el carrito completo.'); } return; }
  if (event.target.closest('[data-cart-close]')) { Charmant.closeCart(); return; }
  const cartChange = event.target.closest('[data-cart-change]');
  if (cartChange) {
    cartChange.disabled = true;
    try { await Charmant.changeCart(cartChange.dataset.cartChange, Number(cartChange.dataset.quantity)); }
    catch { Charmant.toast('No pudimos actualizar el carrito. Inténtalo de nuevo.'); }
    finally { if (cartChange.isConnected) cartChange.disabled = false; }
    return;
  }
  const pageChange = event.target.closest('[data-cart-page-change]');
  if (pageChange) {
    pageChange.disabled = true;
    const quantity = Math.max(Number(pageChange.dataset.currentQuantity) + Number(pageChange.dataset.cartPageChange), 0);
    try {
      await Charmant.changeCart(pageChange.dataset.cartItemKey, quantity);
      window.location.reload();
    } catch {
      pageChange.disabled = false;
      Charmant.toast('No pudimos actualizar la cantidad.');
    }
    return;
  }
  if (event.target.closest('[data-filter-toggle]')) { document.querySelector('[data-collection-filters]')?.classList.toggle('is-open'); document.body.classList.toggle('filters-open'); return; }
  const zoom = event.target.closest('[data-gallery-zoom]');
  if (zoom) { event.preventDefault(); const lightbox = document.querySelector('[data-product-lightbox]'); const image = lightbox?.querySelector('[data-product-lightbox-image]'); if (lightbox && image) { image.src = zoom.href; image.alt = zoom.querySelector('img')?.alt || ''; lightbox.hidden = false; document.body.classList.add('menu-open'); } return; }
  if (event.target.closest('[data-product-lightbox-close]') || event.target.matches('[data-product-lightbox]')) { const lightbox = document.querySelector('[data-product-lightbox]'); if (lightbox) { lightbox.hidden = true; document.body.classList.remove('menu-open'); } return; }
  const soon = event.target.closest('[data-coming-soon]');
  if (soon) { event.preventDefault(); Charmant.toast(soon.dataset.message || 'La colección Caballero llegará muy pronto.'); return; }
  if (event.target.closest('[data-mobile-toggle]')) { const toggle = event.target.closest('[data-mobile-toggle]'); const menu = document.querySelector('[data-mobile-nav]'); const willOpen = menu.hidden; Charmant.closePanels(); menu.hidden = !willOpen; toggle.setAttribute('aria-expanded', String(willOpen)); document.body.classList.toggle('menu-open', willOpen); return; }
  if (event.target.closest('[data-search-toggle]')) { const toggle = event.target.closest('[data-search-toggle]'); const panel = document.querySelector('[data-search-panel]'); const willOpen = panel.hidden; Charmant.closePanels(); panel.hidden = !willOpen; toggle.setAttribute('aria-expanded', String(willOpen)); document.body.classList.toggle('menu-open', willOpen); if (willOpen) window.setTimeout(() => panel.querySelector('input')?.focus(), 50); }
});

document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { Charmant.closeCart(); Charmant.closePanels(); document.querySelector('[data-collection-filters]')?.classList.remove('is-open'); document.body.classList.remove('filters-open'); const lightbox = document.querySelector('[data-product-lightbox]'); if (lightbox) lightbox.hidden = true; } });
window.addEventListener('scroll', () => document.querySelector('[data-header-shell]')?.classList.toggle('is-scrolled', window.scrollY > 40), { passive: true });

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('[data-ajax-product-form]')) return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  const original = button.textContent;
  button.disabled = true;
  button.textContent = 'AGREGANDO…';
  try {
    const response = await fetch(`${Charmant.routes.add}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'No se pudo agregar');
    }
    await Charmant.openCart();
    Charmant.toast('Prenda agregada al carrito');
  } catch (error) { Charmant.toast(error.message || 'Revisa la talla seleccionada e inténtalo de nuevo.'); }
  finally { button.disabled = false; button.textContent = original; }
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-sort-by]')) event.target.form.submit();
  if (event.target.matches('[data-product-select], [data-product-radio]')) {
    const source = event.target.matches('select') ? event.target.selectedOptions[0] : event.target;
    const root = event.target.closest('[data-product-root]');
    const price = root?.querySelector('[data-product-price]');
    const selected = root?.querySelector('[data-selected-variant]');
    const add = event.target.closest('form')?.querySelector('.product-add');
    if (price && source.dataset.price) {
      price.innerHTML = source.dataset.comparePrice
        ? `<s>${Charmant.escape(source.dataset.comparePrice)}</s><strong>${Charmant.escape(source.dataset.price)}</strong><small>Ahorra ${Charmant.escape(source.dataset.saving)} · ${Charmant.escape(source.dataset.discount)}% DE DESCUENTO</small>`
        : `<strong>${Charmant.escape(source.dataset.price)}</strong>`;
    }
    if (selected) selected.textContent = source.dataset.variantTitle || source.textContent || source.value;
    if (add) { add.disabled = source.disabled; add.textContent = source.disabled ? 'AGOTADO' : (root?.dataset.demoProduct === 'true' ? 'AGREGAR PRODUCTO DEMO' : 'AGREGAR AL CARRITO'); }
    const stock = root?.querySelector('[data-stock-note]');
    const quantity = root?.querySelector('input[name="quantity"]');
    const inventory = Number(source.dataset.inventory || 0);
    if (quantity) {
      if (source.dataset.inventoryTracked === 'true' && source.dataset.inventoryPolicy === 'deny') quantity.max = String(Math.max(inventory, 1));
      else quantity.removeAttribute('max');
      if (Number(quantity.value) > Number(quantity.max || quantity.value)) quantity.value = quantity.max;
    }
    if (stock) {
      const showLowStock = source.dataset.inventoryTracked === 'true' && inventory > 0 && inventory < 8;
      stock.hidden = !showLowStock;
      if (showLowStock) stock.textContent = 'PIEZA DE EDICIÓN LIMITADA';
    }
    if (source.value) window.history.replaceState({}, '', `${window.location.pathname}?variant=${source.value}`);
  }
});
const charmantPolicyTitles={
  '/policies/privacy-policy':'Política de privacidad y tratamiento de datos',
  '/policies/refund-policy':'Cambios, devoluciones, retracto y garantía',
  '/policies/shipping-policy':'Política de envíos y entregas',
  '/policies/terms-of-service':'Términos y condiciones de uso y venta'
};
const charmantPolicyTitle=charmantPolicyTitles[window.location.pathname];
if(charmantPolicyTitle){
  const policyHeading=document.querySelector('.shopify-policy__title h1');
  if(policyHeading) policyHeading.textContent=charmantPolicyTitle;
}
